import { render, staticRenderFns } from "./check_info.vue?vue&type=template&id=c4950a64&"
import script from "./check_info.vue?vue&type=script&lang=js&"
export * from "./check_info.vue?vue&type=script&lang=js&"
import style0 from "./check_info.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports